// extracted by mini-css-extract-plugin
export default {"title":"accordeon_title__PaY0J","arrow":"accordeon_arrow__d5WcA","shown":"accordeon_shown__8q8hY"};